import { Popover, PopoverContent, PopoverTrigger } from "@radix-ui/react-popover";
import { Info } from "lucide-react";
import { ReactElement } from "react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "src/components/ui/tooltip";
import { useIsMobile } from "src/hooks/useMobile";

interface ResultsSidebarDetailsTooltipProps {
  tooltip?: string;
}

// todo can probably be moved to its own component
const ResultsSidebarDetailsTooltip = ({ tooltip }: ResultsSidebarDetailsTooltipProps): ReactElement | null => {
  const { isMobile } = useIsMobile();

  if (!tooltip) {
    return null;
  }

  if (isMobile) {
    return (
      <Popover>
        <PopoverTrigger>
          <Info className="size-4" />
        </PopoverTrigger>
        <PopoverContent
          side="top"
          sideOffset={10}
        >
          <div className="absolute bottom-0 right-0 z-50 w-[250px] overflow-visible rounded-3xl bg-black p-4 text-base text-white text-center">
            {tooltip}
          </div>
        </PopoverContent>
      </Popover>
    );
  }

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Info className="size-4" />
        </TooltipTrigger>
        <TooltipContent>
          {tooltip}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default ResultsSidebarDetailsTooltip;
